import React from 'react';

import { FieldList } from 'components/FieldList/FieldList';
import { Heading } from 'components/Heading/Heading';
import type { SectionField, Section as SectionType } from 'models';

import './Section.scss';

type SectionProps = Pick<SectionType<SectionField>, 'fields'> & {
  name?: string;
  description?: string | null;
};

const Section = ({ description, fields, name }: SectionProps) => {
  return (
    <section className="SectionList-section">
      {name && (
        <Heading as="h2" size="medium" className="marginBottom-lg">
          {name}
        </Heading>
      )}
      {description && <p className="Section-description">{description}</p>}
      <FieldList fields={fields} />
    </section>
  );
};

export { Section };
